import axios from 'axios';
import dayjs from 'dayjs';

export default {
  async getSites() {
    return await axios({
      url: '/api/tenant/site',
    })
      .then(r => r.data)
      .then(data => {
        return data.map(site => {
          site.plannedStartDate = site.plannedStartDate ? dayjs(site.plannedStartDate) : null;
          return site;
        });
      });
  },
  async getSitesWithFilters(filter) {
    return await axios({
      method: 'post',
      url: '/api/tenant/site/list',
      data: filter,
    })
      .then(r => r.data)
      .then(data => {
        return data.map(site => {
          site.plannedStartDate = site.plannedStartDate ? dayjs(site.plannedStartDate) : null;
          return site;
        });
      });
  },
  async getSite(id) {
    return await axios({
      url: '/api/tenant/site/' + id,
    }).then(r => r.data);
  },
  async updateSite(id, data) {
    return await axios({
      url: '/api/tenant/site/' + id,
      method: 'put',
      data,
    }).then(r => r.data);
  },
  async updateSiteStatus(id, status) {
    return await axios({
      url: `/api/tenant/site/${id}/status/${status}`,
      method: 'put',
    }).then(r => r.data);
  },
  async updateSiteWorkStatus(siteId, workId, status) {
    return await axios({
      url: `/api/tenant/site/${siteId}/work/${workId}/status/${status}`,
      method: 'put',
    }).then(r => r.data);
  },
  async createSite(data) {
    return await axios({
      url: '/api/tenant/site/',
      method: 'post',
      data,
    }).then(r => r.data);
  },
  async setFavorite(id) {
    return await axios({
      url: `/api/tenant/site/${id}/favorite`,
      method: 'put',
    }).then(r => r.data);
  },
  async removeFavorite(id) {
    return await axios({
      url: `/api/tenant/site/${id}/favorite`,
      method: 'delete',
    }).then(r => r.data);
  },
  async downloadDimensionCSV() {
    return await axios({
      url: '/api/tenant/site/dimension-csv',
      method: 'get',
      headers: {
        Accept: 'text/csv',
      },
      responseType: 'blob',
    }).then(r => r.data);
  },
};
